import { FormLabel, Text } from '@chakra-ui/react';

export default function RefundFormLabel({ children, required = false, ...props }) {
  return (
    <FormLabel
      fontSize="sm"
      fontWeight="semibold"
      color="gray.700"
      mb={2}
      requiredIndicator={null}
      {...props}
    >
      {children}
      {required && (
        <Text as="span" color="red.500" ml={1}>
          *
        </Text>
      )}
    </FormLabel>
  );
}
